import React from 'react';
import { Grid, Box, Divider, Typography, CircularProgress } from '@mui/material';
import { FormSection, TextField, Select } from '../../../../design-system/components/forms';
import { VENDOR_TYPES } from '../../../../constants/vendorConstants';

const VendorBasicInfoForm = ({ formik, isCheckingName, nameExists }) => {
  const handleChange = (field) => (e) => {
    const value = e.target.value;
    if (field.includes('.')) {
      const keys = field.split('.');
      let current = formik.values;
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      formik.setFieldValue(field, value);
    } else {
      formik.setFieldValue(field, value);
    }
  };

  console.log('[VendorBasicInfoForm] Formik values:', formik.values);
  
  return (
    <FormSection title="Basic Information">
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Vendor Name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            required
            InputProps={{
              endAdornment: isCheckingName && <CircularProgress size={20} />
            }}
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Select
            label="Vendor Type"
            name="type"
            value={formik.values.type}
            onChange={(value) => formik.setFieldValue('type', value)}
            options={VENDOR_TYPES}
            error={formik.touched.type && Boolean(formik.errors.type)}
            helperText={formik.touched.type && formik.errors.type}
            required
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Select
            label="Status"
            name="status"
            value={formik.values.status}
            onChange={(value) => formik.setFieldValue('status', value)}
            options={[
              { value: 'active', label: 'Active' },
              { value: 'inactive', label: 'Inactive' },
              { value: 'suspended', label: 'Suspended' }
            ]}
            error={formik.touched.status && Boolean(formik.errors.status)}
            helperText={formik.touched.status && formik.errors.status}
            required
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            label="Tax ID"
            name="taxId"
            value={formik.values.taxId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.taxId && Boolean(formik.errors.taxId)}
            helperText={formik.touched.taxId && formik.errors.taxId}
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            label="Description"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.description && Boolean(formik.errors.description)}
            helperText={formik.touched.description && formik.errors.description}
            multiline
            rows={3}
            placeholder="Brief description of vendor services"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            label="Notes"
            name="notes"
            value={formik.values.notes}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.notes && Boolean(formik.errors.notes)}
            helperText={formik.touched.notes && formik.errors.notes}
            multiline
            rows={3}
            placeholder="Additional notes about this vendor"
          />
        </Grid>
        
        <Grid item xs={12}>
          <Divider sx={{ my: 2 }}>
            <Typography variant="subtitle2" color="textSecondary">
              Contact Information
            </Typography>
          </Divider>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            label="Email"
            name="contact.email"
            value={formik.values.contact.email}
            onChange={handleChange('contact.email')}
            onBlur={formik.handleBlur}
            error={formik.touched.contact?.email && Boolean(formik.errors.contact?.email)}
            helperText={formik.touched.contact?.email && formik.errors.contact?.email}
            type="email"
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            label="Phone"
            name="contact.phone"
            value={formik.values.contact.phone}
            onChange={handleChange('contact.phone')}
            onBlur={formik.handleBlur}
            error={formik.touched.contact?.phone && Boolean(formik.errors.contact?.phone)}
            helperText={formik.touched.contact?.phone && formik.errors.contact?.phone}
            type="tel"
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            label="Website"
            name="contact.website"
            value={formik.values.contact.website}
            onChange={handleChange('contact.website')}
            onBlur={formik.handleBlur}
            error={formik.touched.contact?.website && Boolean(formik.errors.contact?.website)}
            helperText={formik.touched.contact?.website && formik.errors.contact?.website}
          />
        </Grid>
        
        <Grid item xs={12}>
          <Divider sx={{ my: 2 }}>
            <Typography variant="subtitle2" color="textSecondary">
              Address
            </Typography>
          </Divider>
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            label="Street Address"
            name="contact.address.street"
            value={formik.values.contact.address.street}
            onChange={handleChange('contact.address.street')}
            onBlur={formik.handleBlur}
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            label="City"
            name="contact.address.city"
            value={formik.values.contact.address.city}
            onChange={handleChange('contact.address.city')}
            onBlur={formik.handleBlur}
          />
        </Grid>
        
        <Grid item xs={12} md={3}>
          <TextField
            label="State/Province"
            name="contact.address.state"
            value={formik.values.contact.address.state}
            onChange={handleChange('contact.address.state')}
            onBlur={formik.handleBlur}
          />
        </Grid>
        
        <Grid item xs={12} md={3}>
          <TextField
            label="Postal Code"
            name="contact.address.postalCode"
            value={formik.values.contact.address.postalCode}
            onChange={handleChange('contact.address.postalCode')}
            onBlur={formik.handleBlur}
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            label="Country"
            name="contact.address.country"
            value={formik.values.contact.address.country}
            onChange={handleChange('contact.address.country')}
            onBlur={formik.handleBlur}
          />
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default VendorBasicInfoForm;